// @avantia common-code
import { ensureDefined, SMap } from '@avantia/client-and-server-utilities';
import { lodash } from '@avantia/lodash';

// eslint-disable-next-line @typescript-eslint/ban-types
const registeredFunctions: SMap<SMap<Function>> = {};

// eslint-disable-next-line @typescript-eslint/ban-types
export function registerCustomFunctions(questionSetId: string, funcs: SMap<Function>): void {
  ensureDefined(questionSetId, 'questionSetId');

  lodash.forOwn(funcs, (func, key) => {
    if (typeof func !== 'function') {
      throw new Error(`The value provided for ${key} is not a function.`);
    }

    if (!registeredFunctions[questionSetId]) {
      registeredFunctions[questionSetId] = {};
    }

    registeredFunctions[questionSetId][key] = func;
  });
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function getCustomFunction(questionSetId: string, name: string): Function {
  let qs = registeredFunctions[questionSetId];
  let func = qs ? qs[name] : null;
  if (!func) {
    qs = registeredFunctions['*'];
    func = qs ? qs[name] : null;
    if (!func) {
      throw new Error(`There is no function registered with name "${name}" for questionSet "${questionSetId}".`);
    }
  }

  return func;
}
